import axios from "axios";
import { serverUrl } from "./variable";
import Swal from "sweetalert2";

export const postDataWithResponse = (
    url,
    formData,
    decryptedUser,
    responseHandler,
    errorHandler
) => {
    axios.post
        (
            serverUrl + url,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser}`,
                    'content-type': 'multipart/form-data'
                }
            }
        )
        .then((response) => {
            // console.log(response);
            responseHandler(response.data)
        })
        .catch((error) => {
            errorHandler(error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response.data.message || error.response.data
            })
        })
}

export const postDelete = (
    url,
    formData,
    decryptedUser,
    setLoading,
    afterSubmit
) => {
    setLoading !== null && setLoading(true)
    axios.post(
        serverUrl + url,
        formData,
        {
            headers: {
                'Authorization': `Bearer ${decryptedUser}`,
                'content-type': 'multipart/form-data'
            }
        })
        .then((response) => {
            Swal.fire('Berhasil!', response.data, 'success');
            afterSubmit()
        })
        .catch((error) => {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response.data.message || error.response.data
            })
        })
}

export const postSubmit = (
    url,
    formData,
    decryptedUser,
    responseHandler,
    errorHandler
) => {
    axios.post(
        serverUrl + url,
        formData,
        {
            headers: {
                'Authorization': `Bearer ${decryptedUser}`,
                'content-type': 'multipart/form-data'
            }
        })
        .then((response) => {
            // console.log(response);
            responseHandler(response)
            Swal.fire({
                icon: 'success',
                title: 'Berhasil!',
                text: response.data
            })
        })
        .catch((error) => {
            errorHandler(error);
            Swal.fire({
                icon: 'error',
                title: error.response.status,
                text: error.response.data.message || error.response.data
            })
        })
}